import {createSelector, createSlice} from '@reduxjs/toolkit';

import {loadCustomLinkConfig} from 'features/provide-custom-link/api/thunks';
import {CUSTOM_LINK_SLICE} from 'features/provide-custom-link/model/constants';
import {TCustomLinkSliceState} from 'features/provide-custom-link/model/types';
import {TAppState} from 'store/config/types';

export const customLinkSlice = createSlice({
    initialState: {
        customLinks: {},
        isFileLoading: false,
    } as TCustomLinkSliceState,
    name: CUSTOM_LINK_SLICE,
    reducers: {
        startFileLoading(state) {
            state.isFileLoading = true;
        },
        stopFileLoading(state) {
            state.isFileLoading = false;
        },
    },
    extraReducers: builder => {
        builder.addCase(loadCustomLinkConfig.fulfilled, (state, action) => {
            const {
                payload,
                meta,
            } = action;

            if (payload?.status === 200 && payload?.data) {
                const {key} = meta.arg;
                state.customLinks[key] = payload?.data;
            }
        });
    },
});

const selectCustomLinkSliceState = (state: TAppState) => state[CUSTOM_LINK_SLICE];

export const selectCustomLinkConfig = createSelector([
    selectCustomLinkSliceState,
    (_, data: {key: string}) => data], (
    state, {key},
) => state.customLinks[key]);

export const selectIsFileLoading = createSelector(
    selectCustomLinkSliceState,
    ({isFileLoading}) => isFileLoading,
);

export const customLinkSelectors = {
    selectCustomLinkSliceState,
    selectCustomLinkConfig,
    selectIsFileLoading,
};

export const {
    reducer: customLinkSliceReducer,
    actions: customLinkSliceActions,
} = customLinkSlice;

export const {
    startFileLoading,
    stopFileLoading,
} = customLinkSlice.actions;
